import React from 'react';
import Search from '../../../BaseModule/Components/Search/Search';

export interface SearchCaseContactFilterValues {
	fulltext?: string;
}

interface Props {
	onFilter: (filter: SearchCaseContactFilterValues) => void;
}

const SearchCaseContactFilter: React.FC<Props> = ({ onFilter }) => {
	const handleSearch = (fulltext: string) => {
		onFilter({ fulltext });
	};

	return <Search handleSearch={handleSearch} placeholder='base.startTyping' />;
};

export default SearchCaseContactFilter;
